export const FORM_UNSUBSCRIBE = 'page.direct_mail.form.unsubscribe';
